import React, { ReactNode } from "react"
import { Box, Stack, Text } from "@chakra-ui/react"
import { LeadRetrievalUser } from "sharedTypes"
import InfoSegment from "../InfoSegment"

type Props = {
  leadRetrievalUser: LeadRetrievalUser
  description?: ReactNode
}

const AlreadyHaveLicenseScreen = ({ leadRetrievalUser, description }: Props) => (
  <>
    <InfoSegment />
    <Stack spacing={5} textAlign="center">
      <Box mt={2} mb={6}>
        <Text>The email address <b>{leadRetrievalUser.email}</b> {" "}
          is already associated with this event.
        </Text>
        {description || (
          <Text>Please return to the previous page and use a different email address.</Text>
        )}
      </Box>
    </Stack>
  </>
)

export default AlreadyHaveLicenseScreen
